import React from "react"
import { CustomerContext } from "../CustomerProvider"
import { CustomerSite, Customer } from "@hydrologiq/gql-experience/graphql"

export function useCustomer(): Customer | undefined {
  const context = React.useContext(CustomerContext)
  if (context === undefined) {
    throw new Error("loadCustomer must be used within a CustomerProvider")
  }
  return context.customer
}

export function useCustomerSite(): CustomerSite | undefined {
  const context = React.useContext(CustomerContext)
  if (context === undefined) {
    throw new Error("loadCustomer must be used within a CustomerProvider")
  }
  return context.site
}

export function useCustomerLoading(): boolean {
  const context = React.useContext(CustomerContext)
  if (context === undefined) {
    throw new Error("loadCustomer must be used within a CustomerProvider")
  }
  return context.loading ?? false
}

export function useCustomerError(): string | undefined {
  const context = React.useContext(CustomerContext)
  if (context === undefined) {
    throw new Error("loadCustomer must be used within a CustomerProvider")
  }
  return context.error ?? undefined
}

export function useUpdateCustomer(): (nCustomer: Partial<Customer>) => void {
  const context = React.useContext(CustomerContext)
  if (context === undefined) {
    throw new Error("loadCustomer must be used within a CustomerProvider")
  }
  return context.updateCustomer
}

export function useUpdateSite(): (nSite: Partial<CustomerSite>) => void {
  const context = React.useContext(CustomerContext)
  if (context === undefined) {
    throw new Error("loadCustomer must be used within a CustomerProvider")
  }
  return context.updateSite
}

export function useArchiveCustomer(): () => void {
  const context = React.useContext(CustomerContext)
  if (context === undefined) {
    throw new Error("loadCustomer must be used within a CustomerProvider")
  }
  return context.archive
}
